import { render, staticRenderFns } from "./VueHorizontalTimeline.vue?vue&type=template&id=2b1a66cb&scoped=true"
import script from "./VueHorizontalTimeline.vue?vue&type=script&lang=js"
export * from "./VueHorizontalTimeline.vue?vue&type=script&lang=js"
import style0 from "./VueHorizontalTimeline.vue?vue&type=style&index=0&id=2b1a66cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a66cb",
  null
  
)

export default component.exports